import type { APPBaseTokenConfig } from '../types/app';

/**
 * Persistence shape for the app-setting store. Base-token config objects carry
 * icon component functions that JSON persistence silently drops — rendering a
 * rehydrated baseToken.icon crashes with React #130 on the SECOND page load.
 * So we persist only the address and resolve the live config entry on rehydrate.
 * Kept as pure functions (no config imports) so the round-trip is unit-testable.
 */

export const partializeAppSetting = (state: { onboardOpen: boolean; baseToken?: { address?: string } }) => ({
  onboardOpen: state.onboardOpen,
  baseTokenAddress: state.baseToken?.address,
});

type ResolveToken = (address?: string) => APPBaseTokenConfig | undefined;

// The persisted?.baseToken?.address fallback recovers the legacy object-shaped
// state (pre address-only persistence) without forcing a version bump.
export const mergeAppSetting =
  (resolve: ResolveToken, fallback: APPBaseTokenConfig) =>
  <C extends { onboardOpen: boolean }>(persisted: any, current: C) => ({
    ...current,
    onboardOpen: persisted?.onboardOpen ?? current.onboardOpen,
    baseToken: resolve(persisted?.baseTokenAddress ?? persisted?.baseToken?.address) || fallback,
  });
